__turbopack_context__.v({
  "map-card": "_2zU4bq_map-card",
  "map-card__action": "_2zU4bq_map-card__action",
  "map-card__actions": "_2zU4bq_map-card__actions",
  "map-card__back-btn-wrapper": "_2zU4bq_map-card__back-btn-wrapper",
  "map-card__dates": "_2zU4bq_map-card__dates",
  "map-card__dates-timestamps": "_2zU4bq_map-card__dates-timestamps",
  "map-card__day": "_2zU4bq_map-card__day",
  "map-card__product-availability": "_2zU4bq_map-card__product-availability",
  "map-card__store-assortments": "_2zU4bq_map-card__store-assortments",
  "map-card__store-assortments-header": "_2zU4bq_map-card__store-assortments-header",
  "map-card__store-assortments-item": "_2zU4bq_map-card__store-assortments-item",
  "map-card__store-info": "_2zU4bq_map-card__store-info",
});
